/**
 * useShellDomainChrome - the screen's furniture: the async dialog and the log
 * overlay (its view, filter, yield and toasts; its curtain is made in
 * ShellMain).
 *
 * A domain hook: it reads what it needs from the shell scope `s` and returns
 * what it declares (see DeathWatchSimulator). Hook order unchanged.
 * Extracted from DeathWatchSimulator.
 */
import useDialog from './useDialog.js';
import useLogOverlay, { resolveLogView } from './useLogOverlay.js';

/**
 * @param {object} s - the shell scope; reads `sessionId`.
 * @returns {object} the dialog and the log overlay's
 *   controls, plus `logView` (the preference resolved for this session).
 */
export default function useShellDomainChrome(s) {
  const { sessionId } = s;
  const { dialog, showDialogAsync, handleDialogClose } = useDialog();
  // The log's view, lanes, toasts and BORROW. Its curtain (height, collapsed,
  // the grip) is made in ShellMain (useLogCurtain, plan design-gaps L3); the
  // sync below only needs the yield.
  const {
    view: logViewPref,
    setView: setLogView,
    lanesOff: logLanesOff,
    toggleLogLane,
    logExpandAll,
    toggleLogExpandAll,
    chatToasts,
    borrow: logBorrow,
  } = useLogOverlay();
  const logView = resolveLogView(logViewPref, sessionId);
  return {
    dialog,
    showDialogAsync,
    handleDialogClose,
    logViewPref,
    setLogView,
    logBorrow,
    setLogYield: logBorrow.setYield,
    logLanesOff,
    toggleLogLane,
    logExpandAll,
    toggleLogExpandAll,
    chatToasts,
    summonLog: logBorrow.summon,
    logView,
  };
}
